<template>
   <v-card v-model="level.dialogValues.dialogShow" data-app="true" >

      <CardUpdatableHeader :row="row" :level="level"/>

      <v-card-text>

         <v-form v-model="isFormValid">

         <v-container>

            <v-row dense>
               <h3>{{ $t('subtitles.properties') }} ({{row.ctc_pk}})</h3>
               <v-col cols="12">
                  <v-text-field
                  v-model="row.ctc_email"
                  :disabled="level.dialogValues.form_disabled" 
                  :label="$t('texts._email')"
                   :rules="level.dialogOptions.emailRules"
                  ></v-text-field>
               </v-col>
            </v-row>

            <v-row dense>
               <v-col cols="12" sm="6">
                  <v-text-field
                     v-model="row.ctc_firstname"
                     :disabled="level.dialogValues.form_disabled"
                     :label="$t('texts._firstname')"
                     :rules="level.dialogOptions.BMNameRules"
                  >
                  </v-text-field>
               </v-col>
               <v-col cols="12" sm="6">
                  <v-text-field
                     v-model="row.ctc_lastname"
                     :disabled="level.dialogValues.form_disabled"
                     :label="$t('texts._lastname')"
                     :rules="level.dialogOptions.BMNameRules"
                  >
                  </v-text-field>
               </v-col>
            </v-row>

            <v-row dense>
               <v-col cols="12" sm="6">
                  <v-text-field
                  v-model="row.ctc_organizationname"
                  :disabled="level.dialogValues.form_disabled" 
                  :label="$t('texts.ctc_organizationname')"
                  ></v-text-field>
               </v-col>
               <v-col cols="12" sm="6">
                  <ddoSelect2
                     :callbacks="CTTcallbacks"
                     ref="mySelectCTT"
                     :options="CTToptions"
                  >
                     <template v-slot:selection="data">
                        <v-chip
                           v-bind="data.attrs"
                           :input-value="data.selected"
                           close
                           @click:close="$refs.mySelectCTT.remove(data.item)"
                        >
                           <span>{{data.item.ctt_name}}</span>
                        </v-chip>
                     </template>

                     <template v-slot:item="data">
                        <v-list-item-content>
                           <v-list-item-title>{{data.item.ctt_name}}</v-list-item-title>
                        </v-list-item-content>
                     </template>
                  </ddoSelect2>
               </v-col>
            </v-row>

            <v-row dense>
               <v-col cols="12" sm="6">
                  <v-text-field
                  v-model="row.ctc_vatnumber"
                  :disabled="level.dialogValues.form_disabled" 
                  :label="$t('texts.ctc_vatnumber')"
                  ></v-text-field>
               </v-col>
               <v-col cols="12" sm="6">
                  <v-text-field
                  v-model="row.ctc_bm_id_text"
                  disabled
                  :label="$t('texts.ctc_bm_id')"
                  ></v-text-field>
               </v-col>
            </v-row>

            <v-row dense>
               <v-col cols="12" sm="6">
                  <v-text-field
                  v-model="row.ctc_bm_address_billing_id_text"
                  disabled
                  :label="$t('texts.ctc_bm_address_billing_id')"
                  ></v-text-field>
               </v-col>
               <v-col cols="12" sm="6">
                  <v-text-field
                  v-model="row.ctc_bm_address_shipping_id_text"
                  disabled
                  :label="$t('texts.ctc_bm_address_shipping_id')"
                  ></v-text-field>
               </v-col>
            </v-row>

            <v-row>
               <v-col cols="12" sm="6">
                  <h3>{{ $t('subtitles.postal_address') }}</h3>
                  <v-text-field
                     v-model="row.ctc_addr_line1"
                     :disabled="level.dialogValues.form_disabled" 
                     :label="$t('texts.ctc_addr_line1')"
                  ></v-text-field>
                  <v-text-field
                     v-model="row.ctc_addr_line2"
                     :disabled="level.dialogValues.form_disabled" 
                     :label="$t('texts.ctc_addr_line2')"
                  ></v-text-field>
                  <v-text-field
                     v-model="row.ctc_addr_zipcode"
                     :disabled="level.dialogValues.form_disabled" 
                     :label="$t('texts.ctc_addr_zipcode')"
                  ></v-text-field>
                  <v-text-field
                     v-model="row.ctc_addr_city"
                     :disabled="level.dialogValues.form_disabled" 
                     :label="$t('texts.ctc_addr_city')"
                  ></v-text-field>
                  <template>
                     {{ $t('texts.ctc_addr_country') }} <vue-country-code
                        @onSelect="onSelectCountry"
                        ref="MyCountrySelect"
                        :disabledFetchingCountry="true"
                        :preferredCountries="['FR','BE','CA','US']"
                        :dropdownOptions="{ disabledDialCode: true }"
                     >
                     </vue-country-code>
                  </template>
               </v-col>
               <v-col cols="12" sm="6">
                  <h3>{{ $t('subtitles.phones') }}</h3>
                  <h4>{{ $t('subtitles.phone_fixed') }}</h4>
                  <VuePhoneNumberInput
                     v-model="row.ctc_phones.ctc_phone_fixed_phone.nationalNumber"
                     :default-country-code="row.ctc_phones.ctc_phone_fixed_phone.country"
                     :label="$t('texts.ctc_phone_fixed_phone')"
                     :translations="translations"
                     :disabled="level.dialogValues.form_disabled"
                     @update="phone_update_fixed"
                  />
                  <h4>{{ $t('subtitles.phone_cell') }}</h4>
                  <VuePhoneNumberInput
                     v-model="row.ctc_phones.ctc_phone_cell_phone.nationalNumber"
                     :default-country-code="row.ctc_phones.ctc_phone_cell_phone.country"
                     :label="$t('texts.ctc_phone_cell_phone')"
                     :translations="translations"
                     :disabled="level.dialogValues.form_disabled"
                     @update="phone_update_cell"
                  />
               </v-col>
            </v-row>

            <v-row dense>
               <v-col v-if="!level.dialogValues.form_create" cols="12" sm="6">
                  <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.ctc_create,'long') }}<br/>
                  <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.ctc_update,'long') }}
               </v-col>
            </v-row>

         </v-container>
         <small>*{{ $t('texts.requiredfield') }}</small>

         </v-form>

      </v-card-text>

      <CardUpdatableFooter :row="row" :level="level"/>

   </v-card>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import ddoSelect2 from '@/components/ddoSelect2.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import VueCountryCode from 'vue-country-code-select';

export default {
   name: 'CardUpdatableContact',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooter,
      ddoSelect2,
      VuePhoneNumberInput,
      VueCountryCode,
   },

   props: {
      childKey: {
         type: Number,
         default: function () {
            return null;
         }
      },
   },

   data: function () {
      return {
         show: false,
         boolFormValid: false,

         translations: {},

         CTTcallbacks: {},
         CTToptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "ctt_name",
            item_value: "ctt_pk",
            item_disabled: "",
            hide_selected: false,
            change_on_remove: true,
            label: i18n.t('texts.ctt_name'),
         },

      }
   },

   created() {
      this.translations = {
         countrySelectorLabel: i18n.t('texts.countrySelectorLabel'),
         countrySelectorError: i18n.t('texts.countrySelectorError'),
         example: i18n.t('texts.example'),
      }

      this.CTTcallbacks.refresh_rows = this.build_select_ctt;
      this.CTTcallbacks.change       = this.change_ctt;
   },

   mounted() {
      this.load_CountrySelect(this.level.row);
   },

   watch: {
      'row': 'loadOtherInformations',
   },

   computed: {

      isFormValid: {
         get: function() {
            return this.boolFormValid;
         },
         set: function(newValue) {
            console.log('isFormValid, newValue='+newValue)
            this.boolFormValid = newValue;
            if ( this.level.dialogValues.form_create==true ) {
               this.$emit('change_dialogValues',this.level.level,'disable_create',!newValue);
            }
            if ( this.level.dialogValues.form_update==true ) {
               this.$emit('change_dialogValues',this.level.level,'disable_update',!newValue);
            }
         }
      },
   },


   methods: {

      load_CountrySelect(row) {
         if ( row.ctc_addr_country_code ) {
            var country = this.$refs.MyCountrySelect.findCountry(row.ctc_addr_country_code);
            this.$refs.MyCountrySelect.choose(country);
         }
      },

      /*
       * We are not sure this function is really called on 'watch'. Seems not...
       */
      loadOtherInformations(row,oldRow) {
         /*
          * we correctly initialize the CountrySelect component, from 'row.ctc_addr_country_code'
          */
         if ( row.ctc_addr_country_code ) {
            this.load_CountrySelect(row);
         }
         if ( !row.ctc_phones ) {
            row.ctc_phones = { ctc_phone_fixed_phone: null, ctc_phone_cell_phone: null }
         }
         if ( row.ctc_phone_cell_phone!=null ) {
            let parse = parsePhoneNumberFromString(row.ctc_phone_cell_phone);
            if ( parse ) {
               row.ctc_phones.ctc_phone_cell_phone = parse;
            }
         }
         if ( row.ctc_phone_fixed_phone!=null ) {
            let parse = parsePhoneNumberFromString(row.ctc_phone_fixed_phone);
            if ( parse ) {
               row.ctc_phones.ctc_phone_fixed_phone = parse;
            }
         }
         this.CTToptions.selected = row.ctt_pk;
      },

      phone_update_fixed(data) {
         if ( data.isValid ) {
            this.row.ctc_phone_fixed_phone = data.formattedNumber;
         }
      },

      phone_update_cell(data) {
         if ( data.isValid ) {
            this.row.ctc_phone_cell_phone = data.formattedNumber;
         }
      },

      async build_select_ctt(key=null) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,'contacttitle');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async change_ctt(value,item=null) {
         this.row.ctt_pk = value;
      },

      onSelectCountry({name, iso2, dialCode}) {
         this.level.row.ctc_addr_country_code = iso2;
         this.level.row.ctc_addr_country = name;
      },

   },
}
</script>